import React, { Component } from "react";
import PrimaryContact from "./content/PrimaryContact";
import OtherContact from "./content/OtherContact";
import Connector from "./utils/api/Connector";
import Wait from "@react/react-spectrum/Wait";
import AppErrorPage from "../components/errors/AppErrorPage";
import { normalizeApiErrorMessages } from "../components/errors";
import {
  isSavingToggle,
  setGeoPolData,
  setCountryStateMappingData,
} from "../actions/commonActions";
import { connect } from "react-redux";
import { getGeoPolData } from "../getGeoPolDataApi";
import { getCountryStateMappingData } from "../getCountryStateMappingDataApi";

class MPApp extends Component {
  constructor(props) {
    super(props);
    this.connector = new Connector();
  }

  state = {
    isLoading: true,
  };

  refreshApp = () => {
    this.setState({ isLoading: true });
    this.connector.searchEmail(this.onSearchComplete);
  };

  componentDidMount() {
    this.refreshApp();
    getGeoPolData(this.props.setGeoPolDataAction);
  }

  onSearchComplete = async (data) => {
    const cntryData = await getCountryStateMappingData();
    if (cntryData && Object.keys(cntryData)?.length > 0) {
      this.props.setCountryStateMappingDataAction(cntryData);
      this.setState({ data: data, isLoading: false });
    }
  };

  render() {
    return (
      <div>
        {this.props?.isSaving ? (
          <div className="overlay">
            <Wait size="L" centered />
            <span className="saving-Text">Saving</span>
          </div>
        ) : null}
        {this.state?.isLoading ? (
          <Wait size="L" centered />
        ) : this.state.data.isError ? (
          <AppErrorPage
            title="Unable to load this page"
            errorPayload={this.state.data}
            messages={normalizeApiErrorMessages(this.state.data)}
          />
        ) : this?.state?.data?.contactInfo?.mainContactType === "Primary" ||
          this?.state?.data?.contactInfo?.mainContactType === "Secondary" ? (
          <PrimaryContact
            {...this.props}
            partnerData={this.state.data}
            connector={this.connector}
            refreshApp={this.refreshApp}
            profile={this.props.profile}
          />
        ) : (
          <OtherContact
            {...this.props}
            partnerData={this.state.data}
            connector={this.connector}
            refreshApp={this.refreshApp}
            profile={this.props.profile}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isSaving: state?.common?.isSaving,
  profile: state.ims.userProfile,
  geoPolData: state?.common?.geoPolData,
});

const mapDispatchToProps = (dispatch) => ({
  isSavingToggle: (e) => dispatch(isSavingToggle(e)),
  setGeoPolDataAction: (e) => dispatch(setGeoPolData(e)),
  setCountryStateMappingDataAction: (e) =>
    dispatch(setCountryStateMappingData(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MPApp);
